import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import MbTabs from 'components/organisms/MbTabs';

import DisplayPrdtList from './DisplayPrdtList';

const displayFliterStyles = makeStyles((theme) => ({
  root: { maxWidth: 617, padding: '0 25px' },
}));

const DisplayFilterWrap = (props) => {
  const {
    name = 'displayFilter',
    advrtsPrdtCode,
    advrtsTpCode,
    displayFilterList,
    params,
    useDisplayAll,
    onlyProducts,
    onlyTargeting,
    handleProductClick,
    handleSubmit,
    handleTpClick,
  } = props;
  const classes = displayFliterStyles();

  const makeTabMenuList = () => {
    const result = new Map();
    if (onlyProducts && !onlyTargeting) {
      result.set('byProduct', {
        menuUrl: 'byProduct',
        menuSeq: 'byProduct',
        menuNm: '상품별',
      });
    } else if (!onlyProducts && onlyTargeting) {
      result.set('byTargeting', {
        menuUrl: 'byTargeting',
        menuSeq: 'byTargeting',
        menuNm: '타게팅별',
      });
    } else {
      result.set('byProduct', {
        menuUrl: 'byProduct',
        menuSeq: 'byProduct',
        menuNm: '상품별',
      });
      result.set('byTargeting', {
        menuUrl: 'byTargeting',
        menuSeq: 'byTargeting',
        menuNm: '타게팅별',
      });
    }
    return result;
  };

  return (
    <div className={classes.root}>
      <MbTabs
        name={name}
        initValue={
          onlyProducts
            ? 'byProduct'
            : onlyTargeting
            ? 'byTargeting'
            : 'byProduct'
        }
        tabMenuList={makeTabMenuList()}
        changeUrl={false}
        tabs={{
          byProduct: {
            tabComponent: (
              <DisplayPrdtList
                advrtsPrdtCode={advrtsPrdtCode}
                advrtsTpCode={advrtsTpCode}
                displayFilterList={displayFilterList}
                params={params}
                handleSubmit={handleSubmit}
                handleTpClick={handleTpClick}
                useDisplayAll={useDisplayAll}
                handleProductClick={handleProductClick}
              />
            ),
          },
          byTargeting: {
            tabComponent: (
              <DisplayPrdtList
                byTargeting
                advrtsPrdtCode={advrtsPrdtCode}
                advrtsTpCode={advrtsTpCode}
                displayFilterList={displayFilterList}
                params={params}
                handleSubmit={handleSubmit}
                handleTpClick={handleTpClick}
              />
            ),
          },
        }}
        isModal={false}
        popoverTab
      />
    </div>
  );
};

export default DisplayFilterWrap;
